import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const trailerTypeDropdown = async () => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/trailer-type`,
        );

        return response.data.map((item) => ({
            key: item.ttyId,
            text: item.ttyType,
            value: item.ttyId,
        }));
    } catch (e) {
        console.error(e);
    }
};